import { RootState } from 'editor/src/store/index';

const isHiddenAddonsSearch = (state: RootState) => state.hostSettings.hideAddonsSearch;

export default isHiddenAddonsSearch;
